import { render, staticRenderFns } from "./reading-description.vue?vue&type=template&id=78b85a56&scoped=true"
import script from "./reading-description.vue?vue&type=script&lang=js"
export * from "./reading-description.vue?vue&type=script&lang=js"
import style0 from "./reading-description.vue?vue&type=style&index=0&id=78b85a56&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78b85a56",
  null
  
)

export default component.exports